import React, {useState, useEffect} from 'react'
import { HeaderCompleto } from './OldSite/templates/HeaderNavegacion'
import { HeaderSimple } from './OldSite/templates/HeaderSimple'
import { HeaderCaja } from './OldSite/templates/HeaderCaja'
import { ErrorBoundary } from './OldSite/components/Error/ErrorBoundary'
import Styles from './styles.module.sass'
import HeaderSalesforce from './Salesforce'
import { STAGE_PORTAL } from 'constants/general'

const Header = (props) =>{
    const {
        type,
        pageClass = 'hidden',
        rute,
        title = ""
    } = props

    const [upCP, setUpCP] = useState()
    useEffect(()=>{
        if(upCP){
        }
    },[upCP])

    return(
        STAGE_PORTAL !== 'Salesforce'
            ?
                type === 'complete'
                    ?
                        <ErrorBoundary>
                            <div className={Styles?.desktopH}>
                                <HeaderCompleto changeDirectionBar={setUpCP} />
                            </div>
                            <div className={Styles?.movileH}>
                                <HeaderSimple pageClass={'mobile'} />
                            </div>
                        </ErrorBoundary>
                    :
                        type === 'cart'
                            ?
                                <ErrorBoundary>
                                    <HeaderCaja rute={rute} title={title} />
                                </ErrorBoundary>

                            :
                                type === 'simple'
                                    ?
                                        <ErrorBoundary>
                                            <HeaderSimple pageClass={pageClass} />
                                        </ErrorBoundary>
                                    : null
            : <HeaderSalesforce />
    )
} 

export default Header